// https://app.asana.com/0/1201678459219544/1202141624509091/f
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box } from '@wix/design-system';
import React, { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Loader } from '../../common/components/Loader';
import { useAnimation } from '../../common/hooks/useAnimation';
import { useFetchArticle } from '../../common/hooks/useFetchArticle';
import { selectCurrentArticle } from '../../common/selectors/helpCenter';
import { ArticleContainer } from '../../help-center/components/ArticleContainer';
import { Subtitle } from '../../help-center/components/Subtitle';
import { biHelpCenter } from '../../util/bi';
import s from './styles.scss';

export const Article: FC = () => {
  const { articleId, articleUri } = useParams();
  const article = useSelector(selectCurrentArticle);
  const [subtitleText, setSubtitleText] = useState<undefined | string>(
    undefined,
  );

  const activeAnimation = useAnimation(s.moveInRight, s.moveInLeft, [
    articleId,
    articleUri,
  ]);

  useFetchArticle();

  const onTitleHiddenChange = useCallback(
    (value: boolean) => setSubtitleText(value ? article?.title : undefined),
    [article],
  );

  const sendBackBi = () =>
    biHelpCenter.logBackButtonOnArticleView(article?.id!);

  return (
    <Box height="100%" direction="vertical" className={activeAnimation}>
      {article ? (
        <>
          <Subtitle
            text={subtitleText}
            href={article.url}
            sendBackBi={sendBackBi}
            articleId={article.id}
          />
          <ArticleContainer
            article={article}
            onTitleHiddenChange={onTitleHiddenChange}
          />
        </>
      ) : (
        <Loader
          dataHook="article__loader"
          height="100%"
          verticalAlign="middle"
        />
      )}
    </Box>
  );
};
